<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>排班站看板</h3>
          <div class="col-md-4 fontSize20">
            倒數：{{ time }}秒更新, 上次更新時間{{ lastUpdateTime }}
            <button
              type="button"
              @click="refreshPage"
              class="mybtnstyle btn-primary fontSize16"
            >
              重新整理
            </button>
          </div>
          <div class="col-md-8">
            <div class="col-md-6">
              <span class="col-md-12">
                <h4 class="col-md-3">排班站:</h4>
                <select
                  class="inputstyle col-md-5"
                  v-model="select.shiftName"
                  @change="_onShiftAreaChange(select.shiftName)"
                >
                  <option value="insert">--請選擇--</option>
                  <option
                    v-for="station in options.shift_area_arr"
                    :value="station.name"
                  >
                    {{ station.name }}
                  </option>
                </select>
                <button
                  type="button"
                  @click="sendFailingCarMessage"
                  class="mybtnstyle btn-danger fontSize16"
                >
                  發缺車訊息
                </button>
              </span>
            </div>
            <div class="col-md-6">
              <input
                v-model="callNumber"
                type="text"
                required="required"
                class="inputstyle col-md-7 fontSize16"
                placeholder="隊編/呼號"
              />
              <button
                type="button"
                @click="_getDriverHistoryInfo"
                class="mybtnstyle btn-success fontSize16"
              >
                搜尋
              </button>
            </div>
          </div>
          <hr />
          <div class="col-md-12" style="margin-bottom: 10px">
            <h4>手動插班</h4>
            <div class="col-md-2">
              <input
                v-model="transfer.shiftAreaName"
                type="text"
                required="required"
                class="inputstyle col-md-12 fontSize16"
                placeholder="排班站"
                disabled
              />
            </div>
            <div class="col-md-2">
              <input
                v-model="transfer.account"
                type="text"
                required="required"
                class="inputstyle col-md-12 fontSize16"
                placeholder="電話"
                disabled
              />
            </div>
            <div class="col-md-2">
              <input
                v-model="transfer.callNumber"
                type="text"
                required="required"
                class="inputstyle col-md-12 fontSize16"
                placeholder="隊編/呼號"
                disabled
              />
            </div>
            <div class="col-md-2">
              <input
                v-model="transfer.time"
                type="text"
                required="required"
                class="inputstyle col-md-12 fontSize16"
                placeholder="時間"
              />
            </div>
            <div class="col-md-3">
              <button
                type="button"
                @click="_updateShiftSort"
                class="mybtnstyle btn-primary fontSize16"
              >
                自由插班
              </button>
              <button
                type="button"
                @click="_reomveMemberShift"
                class="mybtnstyle btn-danger fontSize16"
              >
                除班
              </button>
              <button
                type="button"
                @click="_clearMemberShift"
                class="mybtnstyle btn-default fontSize16"
              >
                清除資料
              </button>
            </div>
            <div class="col-md-12" style="height: 200px; overflow: auto">
              <table class="table table-striped jambo_table bulk_action">
                <thead>
                  <tr class="headings">
                    <th class="column-title word_center">隊編/呼號</th>
                    <th class="column-title word_center">司機電話</th>
                    <th class="column-title word_center">排班時間</th>
                    <th class="column-title word_center">標記</th>
                    <th class="column-title word_center">插班</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="pointer fontSize16 point text_hailing dropdown"
                    v-for="(item, index) in clickdriverScheduledOnTable"
                  >
                    <td class="word_center">{{ item.callNumber }}</td>
                    <td class="word_center">{{ item.account }}</td>
                    <td class="word_center">{{ item.shiftUpdatedTime }}</td>
                    <td
                      class="word_center"
                      :class="{
                        'red-style':
                          clickdriverScheduledOnTable[index].flag ===
                          '歷史資料',
                      }"
                    >
                      {{ item.flag }}
                    </td>
                    <td
                      class="word_center"
                      v-show="
                        clickdriverScheduledOnTable[index].flag === '歷史資料'
                      "
                    >
                      <button
                        type="button"
                        @click="_clickUpdateShiftSortOnTable(index)"
                        class="mybtnstyle btn-primary fontSize16"
                      >
                        插班
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SampleBroad
      :shiftDriver="shiftDriver"
      @driver-scheduled-info="_getDriverInfo"
    ></SampleBroad>
    <div
      id="modalDriverScheduledInfo"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLabel">司機歷史派遣資料</h3>
          </div>
          <table class="table table-striped jambo_table bulk_action">
            <thead>
              <tr class="headings">
                <th class="column-title word_center">隊編/呼號</th>
                <th class="column-title word_center">司機電話</th>
                <th class="column-title word_center">排班時間</th>
                <th class="column-title word_center">標記</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="pointer fontSize16 point text_hailing dropdown"
                v-for="(item, index) in driverScheduled"
              >
                <td class="word_center">{{ item.callNumber }}</td>
                <td class="word_center">{{ item.account }}</td>
                <td class="word_center">{{ item.shiftUpdatedTime }}</td>
                <td
                  class="word_center"
                  :class="{
                    'red-style': driverScheduled[index].flag === '歷史資料',
                  }"
                >
                  {{ item.flag }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
            <!-- <button type="button" class="btn btn-secondary" @click="" >儲存</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SampleBroad from '../../components/areaComponent/simpleBroad_v1'
import API from '../../assets/js/libs/API'
import moment from 'moment'
// import Shift_area from "../../assets/js/libs/Shift_area";
// import Dispatch_area from "../../assets/js/libs/Dispatch_area";
import { cookies } from '@/utils/cookies'
import Message from '../../assets/js/libs/Message'

let message = new Message()
// var shift_area = new Shift_area();
// var dispatch_area = new Dispatch_area();
export default {
  components: {
    SampleBroad,
  },
  data() {
    return {
      shiftName: [],
      shiftDriver: [],
      stopTime: false,
      time: 16,
      timeout: null,
      driverPhone: '',
      driverScheduled: [],
      clickdriverScheduledOnTable: [],
      callNumber: '',
      options: {
        dispatch_area_arr: [],
        shift_area_arr: [],
      },
      select: {
        shiftName: '',
      },
      transfer: {
        callNumber: '',
        account: '',
        time: '',
        shiftAreaName: '',
      },
      lastUpdateTime: '',
    }
  },
  mounted() {
    this.getShiftInfo()
    this.counter()
    this._getOptions()
  },
  methods: {
    sendFailingCarMessage() {
      let data = {
        announcer: cookies.get('GladName'),
        teamCode: cookies.get('GladTeamCode').toString(),
        content: `目前${this.select.shiftName}缺車，請過去支援`,
      }
      message
        .pushDriverMessage(data, 'all')
        .then((res) => {
          if (res.success) {
            alert('傳送成功')
          } else {
            alert('傳送失敗')
          }
        })
        .catch((err) => {
          console.log(err)
          alert('傳送失敗' + err.message)
        })
    },
    refreshPage() {
      this.$router.go(0)
    },
    counter() {
      if (this.stopTime) {
        this.timeout = null
      } else if (this.time <= 1) {
        this.time = 16
        this.clearSchedualBoard()
        this.getAllShiftDriver()
        this.timeout = setTimeout(this.counter, 1000)
      } else {
        this.timeout = setTimeout(this.counter, 1000)
      }
      this.time -= 1
    },
    startTimer() {
      this.stopTime = false
      this.counter()
      this.getList()
    },
    stopTimer() {
      this.stopTime = true
    },
    clearSchedualBoard() {
      this.shiftDriver = []
    },
    getShiftInfo() {
      API.get(`/shift-area/identificaiton-code`)
        .then((res) => {
          if (res.err === '無此車隊排班站資料') return
          let array = []
          for (let i = 0; i < res.result.length; i++) {
            this.shiftName.push(res.result[i].name)
            // this.shiftName = array.sort()
          }
          this.getAllShiftDriver()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    _getDriverHistoryInfo() {
      if (this.callNumber === '') {
        alert('請輸入隊編/呼號')
        return
      }
      if (this.select.shiftName === '') {
        alert('請選擇排班區')
        return
      }
      API.get(
        `/service/shift/record/?callNumber=${this.callNumber}&shiftAreaName=${this.select.shiftName}`,
      )
        .then((res) => {
          if (res.err === '找不到該位司機的排班資料') {
            alert('找不到該位司機的排班資料')
            return
          }
          let driverArray = res.result.filter((element) => {
            return element.action === 'import'
          })
          let array = this.shiftDriver.filter((element) => {
            if (element.name === this.select.shiftName) {
              return element.driverInfo
            }
          })
          // console.log('====>',array)
          // 排班站內的司機

          // 合併
          let combin = array[0].driverInfo.concat(driverArray)
          // 重新整理
          let sortArray = []
          for (let i = 0; i < combin.length; i++) {
            let info = {}
            info.account = combin[i].account
            info.callNumber = combin[i].callNumber
            info.shiftUpdatedTime = moment(combin[i].shiftUpdatedTime).format(
              'YYYY-MM-DD HH:mm:ss',
            )
            info.shiftAreaName = combin[i].shiftAreaName
            if (combin[i].flag === undefined) {
              info.flag = '歷史資料'
            } else {
              info.flag = combin[i].flag
            }
            sortArray.push(info)
          }
          sortArray.sort(function (a, b) {
            return new Date(a.shiftUpdatedTime) - new Date(b.shiftUpdatedTime)
          })
          this.openModal(sortArray)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    _getShiftRecordAPI(callNumber, shiftName) {
      API.get(
        `/service/shift/record/?callNumber=${callNumber}&shiftAreaName=${shiftName}`,
      )
        .then((res) => {
          if (res.err === '找不到該位司機的排班資料') {
            alert('找不到該位司機的排班資料')
            return
          }
          let driverArray = res.result.filter((element) => {
            return element.action === 'import'
          })
          let array = this.shiftDriver.filter((element) => {
            if (element.name === shiftName) {
              return element.driverInfo
            }
          })
          // console.log('====>',array)
          // 排班站內的司機

          // 合併
          let combin = array[0].driverInfo.concat(driverArray)
          // 重新整理
          let sortArray = []
          for (let i = 0; i < combin.length; i++) {
            let info = {}
            info.account = combin[i].account
            info.callNumber = combin[i].callNumber
            info.shiftUpdatedTime = moment(combin[i].shiftUpdatedTime).format(
              'YYYY-MM-DD HH:mm:ss',
            )
            info.shiftAreaName = combin[i].shiftAreaName
            // console.log(combin[i].flag === undefined)

            if (combin[i].flag === undefined) {
              info.flag = '歷史資料'
            } else {
              info.flag = combin[i].flag
            }
            sortArray.push(info)
          }
          sortArray.sort(function (a, b) {
            return new Date(b.shiftUpdatedTime) - new Date(a.shiftUpdatedTime)
          })
          this.clickdriverScheduledOnTable = sortArray
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getAllShiftDriver() {
      API.get(`/service/shift`)
        .then((res) => {
          let driverSchedualingInfo = []
          this.lastUpdateTime = moment().format('HH:mm:ss')
          if (res.err === '找不到車隊排班資料') {
            driverSchedualingInfo = []
            for (let i = 0; i < this.shiftName.length; i++) {
              let info = {
                name: this.shiftName[i],
                driverInfo: [],
              }
              this.shiftDriver.push(info)
            }
            return
          }
          driverSchedualingInfo = this.sortTime(res.result)
          for (let i = 0; i < this.shiftName.length; i++) {
            let info = null
            let driverInfo = []
            for (let j = 0; j < driverSchedualingInfo.length; j++) {
              if (
                this.shiftName[i] === driverSchedualingInfo[j].shiftAreaName &&
                driverSchedualingInfo[j].state === 4
              ) {
                driverInfo.push({
                  flag: '排班中',
                  account: driverSchedualingInfo[j].account,
                  state: driverSchedualingInfo[j].state,
                  driverNote: driverSchedualingInfo[j].driverNote,
                  callNumber: driverSchedualingInfo[j].callNumber,
                  shiftUpdatedTime: moment(
                    driverSchedualingInfo[j].shiftUpdatedTime,
                  ).format('YYYY-MM-DD HH:mm:ss'),
                })
              }
            }
            info = {
              name: this.shiftName[i],
              driverInfo,
            }
            this.shiftDriver.push(info)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    _clearMemberShift() {
      this.clickdriverScheduledOnTable = []
      this.transfer.callNumber = ''
      this.transfer.account = ''
      this.transfer.time = ''
      this.transfer.shiftAreaName = ''
    },
    openModal(val) {
      this.driverScheduled = val
      $('#modalDriverScheduledInfo').modal('show')
    },
    sortTime(schedualArray) {
      return schedualArray.sort(function (a, b) {
        return new Date(a.shiftUpdatedTime) - new Date(b.shiftUpdatedTime)
      })
    },
    _onShiftAreaChange(val) {
      console.log(val)
    },
    _getOptions() {
      API.get(`/shift-area/identificaiton-code`)
        .then((res) => {
          if (res.err === '無此車隊排班站資料') return
          this.options.shift_area_arr = res.result
          // let schedualArea = res.result;
        })
        .catch((err) => {
          console.log(err + '錯誤代碼: area:001')
        })
    },
    _getDriverInfo(value) {
      this.transfer.callNumber = value.callNumber
      this.transfer.account = value.account
      this.transfer.time = value.shiftUpdatedTime
      this.transfer.shiftAreaName = value.shiftName
      this._getShiftRecordAPI(
        this.transfer.callNumber,
        this.transfer.shiftAreaName,
      )
    },
    _clickUpdateShiftSortOnTable(index) {
      //clickdriverScheduledOnTable
      // console.log(this.clickdriverScheduledOnTable[index])
      let payload = {
        driverPhone: this.clickdriverScheduledOnTable[index].account,
        shiftAreaName: this.clickdriverScheduledOnTable[index].shiftAreaName,
        shiftDate: new Date(
          moment(this.clickdriverScheduledOnTable[index].shiftUpdatedTime)
            .utc()
            .format(),
        ).toISOString(),
      }
      // console.log(payload)
      API.put('service/shift', payload)
        .then((res) => {
          alert(res.message)
          this.clearSchedualBoard()
          this.getAllShiftDriver()
          this.clickdriverScheduledOnTable = []
        })
        .catch((err) => {
          console.log('通知乘客： ' + err)
        })
    },
    _updateShiftSort() {
      let payload = {
        driverPhone: this.transfer.account,
        shiftAreaName: this.transfer.shiftAreaName,
        shiftDate: new Date(
          moment(this.transfer.time).utc().format(),
        ).toISOString(),
      }
      // console.log(payload)
      API.put('service/shift', payload)
        .then((res) => {
          alert(res.message)
          this.clearSchedualBoard()
          this.getAllShiftDriver()
          this.transfer.callNumber = ''
          this.transfer.account = ''
          this.transfer.time = ''
          this.transfer.shiftAreaName = ''
        })
        .catch((err) => {
          console.log('通知乘客： ' + err)
        })
    },
    _reomveMemberShift(info) {
      let payload = {
        callNumber: this.transfer.callNumber,
        shiftAreaName: this.transfer.shiftAreaName,
        driverPhone: this.transfer.account,
      }
      API.delete(`service/shift`, { data: payload })
        .then((res) => {
          if (!res.success) throw new RangeError(res.error)
          alert(res.message)
          this.clearSchedualBoard()
          this.getAllShiftDriver()
          this.transfer.callNumber = ''
          this.transfer.account = ''
          this.transfer.time = ''
          this.transfer.shiftAreaName = ''
        })
        .catch((err) => {
          console.log('通知乘客： ' + err)
        })
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
    this.timeout = null
  },
}
</script>
<style scoped>
.red-style {
  background-color: #ff4d4d;
}
</style>



// WEBPACK FOOTER //
// src/pages/area/ShiftBoard_old.vue